import classNames from "classnames";
import { BuilderComponentProps } from "../BuilderInterface";
import "./style.scss";
import { getCompoundStyle } from "../helpers";

import { useRef } from "react";

const BuilderCFD: React.FC<BuilderComponentProps> = ({
    node,
    children,
    actionCallbacks,
    builderProps
}: BuilderComponentProps) => {
    const { attr, id } = node;

    const div = useRef<HTMLDivElement>(null);

    const builderSectionClass = classNames("builder-cfd", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const { selectCallback, outlineCallback, onDragOverCapture, extraChild, selectedMenu } = builderProps;

        return (
            <div
                {...attr}
                ref={div}
                className={builderSectionClass}
                style={getCompoundStyle({ node })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragOverCapture={e => onDragOverCapture?.(e, id, div.current as HTMLDivElement)}
            >
                {extraChild}
                {children}
                {selectedMenu}
            </div>
        );
    } else {
        return (
            <div {...attr} {...actionCallbacks} className={builderSectionClass} style={getCompoundStyle({ node })}>
                {children}
            </div>
        );
    }
};

export default BuilderCFD;
